export const en_US = {
  pricing_table: {
    year: "Year",
    month: "Month",
    upon_request: "Upon request",
    monthly: "Monthly",
    annual: "Yearly",
    paid_annually: "paid annually",
    currency_label: "Currency",
    language_label: "Language",
    billing_label: "Billing",
    change_your_subscription: "Switch to yearly",
    request_now: "Request now",
    upgrade_now: "Upgrade now",
    contact_support: "Contact support",
    manage_user_profile: "Configure your plan",
    change_number_of_user: "Resources",
    change_number_of_group_appointment: "Group events",
    change_number_of_store: "Locations",
    change_number_of_conference: "Conferences",
    per_month_above_tier_min: "/mo each above tier min",
    sales_calculator_title: "Sales calculator",
    sales_calculator_subtitle: "Pick the cheapest fitting tier; per-unit costs apply above each minimum.",
    per_user_calender: "User",
    per_user_calenders: "Users",
    per_group_appointment: "Group appointment",
    per_group_appointments: "Group appointments",
    per_store: "Store",
    per_stores: "Stores",
    per_conference: "Conference",
    per_conferences: "Conferences",
    price_on_request: "Price on request",
    base: "base",
    charged_monthly: "charged monthly",
    charged_annually: "charged annually",
    best_value: "Best value",
    active: "Active",
    persona_basic: "For solo professionals",
    persona_starter: "For small teams",
    persona_team: "For growing teams",
    persona_enterprise: "For large organisations",
    you_also_unlock: "You also unlock with",
    hero_eyebrow: "Plans & Pricing",
    hero_title_lead: "Pick the plan that",
    hero_title_accent: "grows with you.",
    hero_subtitle: "GDPR-compliant online booking that scales from your first solo appointment to enterprise.",
    compare_all_features: "Compare all features",
    total: "Total",
    close: "Close",
    calenso_pricing: "{{brandName}} Price Calculator",
    rights_reserved: "All rights reserved, <a href='{{websiteUrl}}' target='_blank'>{{brandName}}</a> {{ year }}."
  },
  pricing_compare: {
    hide_comparison: "Hide feature comparison",
    feature_column: "Feature"
  },
  pricing_addons: {
    section_title: "On-demand Add-ons",
    section_subtitle: "Specialized features available across all tiers. Each add-on unlocks a specific capability — contact support to enable it on your account.",
    contact_cta: "Contact support",
    from_price: "from",
    active_badge: "Active",
    active_label: "Active on your plan",
    analytics_name: "Analytics",
    analytics_description: "Advanced booking analytics dashboard with detailed statistics and reporting.",
    room_booking_name: "Room Booking",
    room_booking_description: "Dedicated room and meeting-space booking flow on top of standard appointments.",
    customer_otp_name: "Widget Customer OTP",
    customer_otp_description: "One-time-password verification for customers booking via the public widget.",
    timezone_name: "Timezone Support",
    timezone_description: "Multi-timezone support with partner / worker / customer timezone hierarchy.",
    read_customers_widget_name: "Read Customers on Widget",
    read_customers_widget_description: "Public widget reads customer data by UUID and prefills personal information.",
    multi_partner_worker_name: "Multi-partner Worker",
    multi_partner_worker_description: "Same email worker added to multiple partners — useful for franchise and multi-brand setups.",
    resource_planning_name: "Resource Planning",
    resource_planning_description: "Pre-defined appointment slots created by admins for predictable resource scheduling.",
    hubspot_name: "HubSpot Integration",
    hubspot_description: "HubSpot CRM sync for contacts, companies and appointments.",
    user_sync_name: "User Sync (Entra ID)",
    user_sync_description: "Microsoft Entra ID (Azure AD) synchronization with store-worker mapping.",
    dynamic_combi_name: "Dynamic Combo Services",
    dynamic_combi_description: "Multi-stop tour bookings with directional travel-time matrix and service-scoped routing.",
    graph_api_logging_name: "Microsoft Graph API Logging",
    graph_api_logging_description: "Comprehensive logging of all Microsoft Graph API activity for compliance and audit.",
    condition_engine_name: "Condition Engine",
    condition_engine_description: "Advanced conditional logic on top of the workflows engine — branching rules, multi-criteria triggers, dynamic placeholders."
  }
};
